import useLocale from 'next-translate/useTranslation';

import InstagramLogo from '~/svg/Instagram.svg';
import BusinessInsiderLogo from '~/svg/BusinessInsider.svg';
import TiktokLogo from '~/svg/Tiktok.svg';
import YahooLogo from '~/svg/Yahoo.svg';

export default function FeaturedLogos({
  forceDark = false,
  featuredPublication = 'technoedge',
}: {
  forceDark?: boolean;
  featuredPublication?: 'technoedge' | 'e27';
}) {
  const { t } = useLocale('footer');
  const primaryPublication =
    featuredPublication === 'e27'
      ? {
          href: 'https://e27.co/asias-ai-trust-gap-strong-transparency-weak-security-and-unclear-data-practices-20260826/',
          logo: '/images/e27.png',
          name: 'e27',
        }
      : {
          href: 'https://www.techno-edge.net/article/2023/02/06/830.html',
          logo: '/images/technoedge.png',
          name: 'Technoedge',
        };

  return (
    <div
      className={`py-24 ${
        forceDark ? 'bg-slate-900 dark' : 'bg-gray-100 dark:bg-slate-900'
      }`}
    >
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <h2 className='text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 dark:text-white'>
          {t('As Featured In')}
        </h2>
        <div className='mx-auto mt-10 grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-6'>
          <a
            href={primaryPublication.href}
            target='_blank'
            rel='nofollow noreferrer'
            className='col-span-2 lg:col-span-1'
          >
            <img
              className='col-span-2 max-h-12 w-full object-contain lg:col-span-1 dark:brightness-0 dark:invert'
              src={primaryPublication.logo}
              alt={primaryPublication.name}
            />
          </a>
          <a
            href='https://ascii.jp/elem/000/004/122/4122868/'
            rel='nofollow noreferrer'
            target='_blank'
            className='col-span-2 lg:col-span-1'
          >
            <img
              className='col-span-2 max-h-12 w-full object-contain lg:col-span-1 dark:brightness-0 dark:invert'
              src='/images/ascii.png'
              alt='Ascii'
            />
          </a>
          <a
            href='https://tw.news.yahoo.com/%E7%B6%B2%E8%B7%AF%E7%B4%85%E4%BB%80%E9%BA%BC-%E4%B8%8D%E5%8F%AAchatgpt-%E5%A4%9A%E7%A8%AEai%E5%B7%A5%E5%85%B7%E7%B6%B2%E7%AB%99%E5%B9%AB%E4%BD%A0%E6%B8%9B%E8%BC%95%E5%B7%A5%E4%BD%9C%E8%B2%A0%E6%93%94-230020839.html'
            target='_blank'
            rel='nofollow noreferrer'
            className='col-span-2 lg:col-span-1'
          >
            <YahooLogo className='col-span-2 h-32 w-auto object-contain lg:col-span-1 dark:brightness-0 dark:invert' />
          </a>
          <a
            href='https://www.tiktok.com/@createwithsean/video/7215015599670447378?q=easy-peasy-ai&t=1703927053006'
            target='_blank'
            rel='nofollow noreferrer'
            className='col-span-2 lg:col-span-1'
          >
            <TiktokLogo className='col-span-2 h-32 w-auto object-contain lg:col-span-1 dark:brightness-0 dark:invert' />
          </a>
          <a
            href='https://markets.businessinsider.com/news/stocks/easy-peasy-ai-the-all-in-one-ai-platform-redefining-how-businesses-create-automate-and-innovate-1035586424'
            target='_blank'
            rel='nofollow noreferrer'
            className='col-span-2 lg:col-span-1'
          >
            <BusinessInsiderLogo className='col-span-2 h-32 w-auto object-contain lg:col-span-1 dark:brightness-0 dark:invert' />
          </a>
          <a
            href='https://www.instagram.com/reel/CsjP0kwqqv4/'
            target='_blank'
            rel='nofollow noreferrer'
            className='col-span-2 lg:col-span-1'
          >
            <InstagramLogo className='col-span-2 h-20 w-auto  lg:col-span-1 dark:brightness-2' />
          </a>
        </div>
      </div>
    </div>
  );
}
